<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="520px"
    append-to-body
    :close-on-click-modal="false"
    @open="onOpen"
  >
    <el-form label-width="110px" size="small">
      <el-form-item v-if="!isEditItem" label="岗位" required>
        <el-select v-model="form.stationName" :disabled="!!headerRow" placeholder="请选择岗位" style="width: 100%">
          <el-option v-for="s in stationOptions" :key="s.value" :label="s.label" :value="s.value" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="!isEditItem" label="人员" required>
        <cargo-advance-select
          style="width: 100%"
          filterable
          clearable
          :disabled="!!headerRow"
          :select-type="selectTypeNames.basic_data_User"
          :default-value="form.userId"
          :callback-params="{ key: 'userId' }"
          @parentCallBack="onUserSelected"
        />
      </el-form-item>
      <el-form-item v-if="headerRow" label="人员">
        <span>{{ headerRow.userName || headerRow.userId }}</span>
      </el-form-item>
      <el-form-item label="成本类型" required>
        <el-select v-model="form.costType" placeholder="请选择" style="width: 100%">
          <el-option v-for="t in costTypeOptions" :key="t.value" :label="t.label" :value="t.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="金额" required>
        <el-input-number v-model="form.amount" :min="0" :precision="2" :step="100" style="width: 100%" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="500" show-word-limit />
      </el-form-item>
      <el-form-item label="按月自动累加">
        <el-checkbox v-model="form.autoMonthlyChecked">每月1日自动累加一条相同成本</el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { savePersonCostItem } from '@/api/provision/provisionRule'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ProvisionConstants from '@/class/cargo/model/parameters/ProvisionConstants'

export default {
  name: 'PersonCostEditDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, default: false },
    headerRow: { type: Object, default: null },
    itemRow: { type: Object, default: null }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      stationOptions: ProvisionConstants.CONFIGURABLE_STATIONS,
      costTypeOptions: ProvisionConstants.PERSON_COST_TYPE_OPTIONS,
      form: this.defaultForm()
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    isEditItem() {
      return !!(this.itemRow && this.itemRow.uuid)
    },
    dialogTitle() {
      return this.isEditItem ? '编辑人员成本' : '新增人员成本'
    }
  },
  methods: {
    defaultForm() {
      return {
        stationName: '',
        userId: '',
        userName: '',
        costType: 'base_salary',
        amount: 0,
        remark: '',
        autoMonthlyChecked: false
      }
    },
    onOpen() {
      if (this.itemRow && this.itemRow.uuid) {
        this.form = {
          stationName: this.headerRow ? this.headerRow.stationName : '',
          userId: this.headerRow ? this.headerRow.userId : '',
          userName: this.headerRow ? this.headerRow.userName : '',
          costType: this.itemRow.costType,
          amount: Number(this.itemRow.amount || 0),
          remark: this.itemRow.remark || '',
          autoMonthlyChecked: this.itemRow.autoMonthly === '1'
        }
      } else if (this.headerRow) {
        this.form = {
          ...this.defaultForm(),
          stationName: this.headerRow.stationName,
          userId: this.headerRow.userId,
          userName: this.headerRow.userName
        }
      } else {
        this.form = this.defaultForm()
      }
    },
    onUserSelected(data) {
      if (!data) return
      this.form.userId = data.userId || ''
      this.form.userName = data.chineseName || data.userName || data.userId || ''
    },
    async handleSubmit() {
      if (!this.form.stationName) {
        this.$message.warning('请选择岗位')
        return
      }
      if (!this.form.userId) {
        this.$message.warning('请选择人员')
        return
      }
      if (!this.form.costType) {
        this.$message.warning('请选择成本类型')
        return
      }
      const payload = {
        uuid: this.isEditItem ? this.itemRow.uuid : undefined,
        personCostUuid: this.headerRow ? this.headerRow.uuid : undefined,
        stationName: this.form.stationName,
        userId: this.form.userId,
        userName: this.form.userName,
        costType: this.form.costType,
        amount: this.form.amount,
        remark: this.form.remark,
        autoMonthly: this.form.autoMonthlyChecked ? '1' : '0'
      }
      const res = await savePersonCostItem(payload)
      if (!res.ok) {
        this.$message.error(res.message || '保存失败')
        return
      }
      this.$message.success('保存成功')
      this.dialogVisible = false
      this.$emit('success')
    }
  }
}
</script>
